module.exports = __webpack_public_path__ + "assets/img/appraisalSystem.0ca06c10.png";